import './loader.css';

const LoadingScreen = () => {
    return (
        <div className="loading-screen" role="status" aria-live="polite">
            <div className="spinner"></div>
            <p className="loading-text">Loading page, please wait...</p>
        </div>
    );
};

export default LoadingScreen;

